export default [
  {
    requirement:
      "contravention of any provision of the law relating to housing or landlord and tenant law",
    id: 'law-violation',
  },
  {
    requirement:
      "the landlord's knowledge of private tenancy law and good practice",
    id: 'law-knowledge',
  },
  {
    requirement: "any delay or attempt to avoid registration",
    id: 'registration-avoidance',
  },
  {
    requirement: "failure or delays in providing information",
    id: 'information-provision',
  },
  {
    requirement: "complaints from tenants or neighbours",
    id: 'complaints',
  },
  {
    requirement: "information about the physical condition of the property",
    id: 'property-condition',
  },
  {
    requirement:
      "judgements against the landlord by the Housing and Property Chamber of the First Tier Tribunal (FTT)",
    id: 'tribunal-judgements',
  },
  {
    requirement:
      "any offence involving fraud or other dishonesty, firearms, violence, or drugs",
    id: 'fraud-violence-other-offense',
  },
  {
    requirement: "any sexual offense",
    id: 'sexual-offense',
  },
  {
    requirement:
      "unlawful discrimination in, or in connection with, the carrying on of any business",
    id: 'discrimination',
  },
]